import viLocale from 'element-ui/lib/locale/lang/vi'
const vi_VN = {
    header: {
        user: 'Tên đăng nhập',
        password: 'Mật khẩu',
        forget: 'Quên mật khẩu ?',
        login: 'Đăng nhập',
        register: 'Đăng ký',
        verification: 'Mã xác minh',
        mainAccount: 'Tài khoản chính:',
        mineAccount: 'Tài Khoản Của Tôi',
        inEmail: 'Hộp Thư',
        loginOut: 'Đăng Xuất',
        Betting: 'Lịch sử đặt cược',
        withdraw: 'Rút tiền',
        deposit: 'Nạp tiền',
        transaction: 'Lịch sử giao dịch',
        checkUsername: 'Vui lòng nhập số tài khoản',
        checkPassword: 'Vui lòng nhập mật khẩu của bạn',
        checkVrifyCode: 'Vui lòng điền mã xác minh',
        refresh:'Làm mới thành công',
        seeMore: 'Xem thêm',
        hotDiscount: 'Ưu đãi lớn',
        customer: 'Dịch vụ khách hàng trực tuyến',
        downloadUrl: 'Tải xuống APP',
        Eventhall: 'Phòng sự kiện',
        Mobilebetting: 'Cá cược di động',
        Mobilebettin2: 'Quét để tải xuống APP di động',
        Mobilebettin3: 'Chống cướp và chống nhảy',
        Home:'Trang Chủ',
    },
    register: {
        open: 'Đăng ký ',
        user: 'Tên đăng nhập:',
        userPlace: 'Tên đăng nhập phải chứa 6 -12 ký tự và số  ',
        password: 'Mật khẩu :',
        passwordPlace: 'Mật khẩu phải chứa 6 -12 ký tự và số ',
        phone: 'Số điện thoại:',
        phonePlace: 'Vui lòng nhập số điện thoại ',
        phoneTips: 'Vui lòng nhập chính xác số điện thoại để nhận mã xác minh',
        agent: 'Mã đại lý :',
        agentPlace: 'Có thể không cần nhập ',
        verification: ' Mã xác minh :',
        verificationPlace: 'Vui lòng nhập mã xác minh ',
        rule: 'Tôi đã đủ 18 tuổi. Tôi đã đọc và chấp thuận các Điều khoản & Điều kiện .',
        btn: ' Đăng ký ',
        pleaseRead:'Xin vui lòng đọc chính sách bảo mật',
        download: 'Tải xuống ứng dụng di động',
        style: 'Phương thức gửi tiền',
        paytd: 'Cung cấp các kênh thanh toán nhanh',
        copyright: 'Bản quyền trò chơi',
        realName:'Tên thật',
        realNamePlace:'Hãy nhập tên thật (không cần thiết)',
        realNamePlace_:'Hãy nhập tên thật của bạn',
        qq:'QQ',
        qqPlace:'Hãy nhập số QQ (không cần thiết)',
        qqPlace_:'Hãy nhập số QQ.',
        wx:'wechat',
        wxPlace:'Nhập tín hiệu wechat (không cần thiết)',
        wxPlace_:'Nhập tín hiệu wechat',
        email:'Hộp thư',
        emailPlace:'Hãy nhập email (không cần thiết)',
        emailPlace_:'Hãy nhập email',
        withdrawPassword:'Rút mật khẩu',
        withdrawPasswordPlace:'Hãy nhập mật khẩu rút lui (không cần thiết)',
        withdrawPasswordPlace_:'Hãy nhập mật khẩu rút lui',
    },
    agency:{
        title:'Cơ quan hợp tác',
        affiliateAgree: 'Thỏa thuận liên kết',
        agencyLogin: 'Đăng nhập proxy',
        agencyRegister: 'Đăng ký đại lý'
    },
    download:{
        title:'Trung tâm tải xuống',
        appDownload: 'Tải xuống ứng dụng',
        subTitle: 'Tải xuống điện thoại Android / Apple',
        input: 'Đầu vào trình duyệt di động'
    },
    nav:{
        sbSport:'IBC Sports',
        eSport: 'Esports',
        ugSport: 'UG Sports',
        cmdSport: 'CMD Sports',
        wftSport: 'WFT Sports',
        imSport: 'IM Sports',
        lottery: ' Xổ Số',
        poker: 'poker',
        live: 'Live Casino',
        slot: 'Slots',
        fish: ' Bắn Cá',
        discounts: 'Khuyến Mãi',
        agency: 'Đại Lý ',
        remove: 'Ứng dụng'
    },
    discounts:{
        details:'Tìm chi tiết',
        noDiscounts: 'Không có ưu đãi liên quan!',
        discountsReceived: 'Nhận hoa hồng',
        checkPlatform:'Vui lòng chọn nền tảng',
        checkMoney: 'Vui lòng nhập số tiền ',
        checkMoneyPlace:'Vui lòng nhập số tiền gửi vào sảnh trò chơi',
        cancel: 'Hủy bỏ',
        confrim:'Xác thực',
        checkBisnum:'Vui lòng nhập mã vé cược',
        checkBisnum2:'Vui lòng nhập mã vé cược',
        needLoin:'Chỉ có thể nhận hoa hồng sau khi đăng nhập',
        needLoin2:'Chỉ có thể nhận hoa hồng sau khi đăng nhập ',
        querylevel:'Cấp truy vấn',
        queryresult:'Kết quả kiểm tra',
        account:'Tài khoản người chơi', //账号
        currentlevel:'Cấp bậc hiện tại', //当前等级
        Totalcumulativebets:'Số tiền đặt cược tích lũy', //累计投注
        Accumulatedpromotionbonus:'Tích lũy khuyến mãi', 
        Accumulatedsalary:'Tích lũy Tích lũy hàng tuần', 
        AccumulatedMonthlysalary:'Tích lũy Tích lũy hàng tháng',
        Totalbetamountrequiredforpromotion:'Số tiền đặt cược khuyến mãi'
    },
    forget:{
        RetrieveSMS:'Khôi phục bằng tin nhắn',
        MailboxRetrieve: 'Khôi phục bằng email',
        CustomerRetrieve:'Khôi phục thông qua bộ phận chăm sóc khách hàng',
        sendMsg:'Gửi mã xác minh',
        checking: 'Xác minh',
        finish: 'Hoàn thành',
        userPlace:'Vui lòng nhập tài khoản trò chơi của bạn',
        phonePlace:'Vui lòng liên kết số điện thoại',
        emailPlace:'Vui lòng liên kết hòm thư của bạn',
        sendPhoneMsg:'Gửi mã xác minh điện thoại',
        sendEmailCode: 'Vui lòng liên kết hòm thư của bạn',
        sendEmail:'Gửi mã xác minh hòm thư',
        bindPhone:'Vui lòng liên kết số điện thoại',
        bindEmail:'Vui lòng liên kết hòm thư của bạn',
        verifyPlace:'Vui lòng nhập mã xác minh',
        tips:'Chúng tôi đã gởi mã xác minh đến điện thoại của bạn, vui lòng kiểm tra',
        tips2:'Chúng tôi đã gởi mã xác minh đến điện thoại của bạn, vui lòng kiểm tra',
        newPasswordPlace:'Vui lòng nhập mật khẩu mới',
        reNewPasswordPlace: 'Vui lòng nhập lại mật khẩu mới của bạn',
        check:'Xác minh',
        resetSuccess:'Đặt lại mật khẩu thành công',
        celebrate:'Chúc mừng bạn',
        CustomerService: 'Liên hệ dịch vụ khách hàng',
        sendAgain:'Gửi lại mã xác minh',
        // second: '秒）后重新发送'
    },
    mine: {
        welcome: 'Chào mừng',
        balance: 'THB',
        minecenter: ' Thông Tin Cá Nhân',
        amountManage: 'Quản Lý Ngân Sách',
        Betting: 'Lịch Sử Đặt Cược',
        welfare: ' Danh Sách Quà Tặng',
        transaction: 'Lịch Sử Giao Dịch',
        myDiscount: 'Ưu đãi của bạn',
        safe: 'Bảo Mật Tài Khoản',
        inEmail: 'Hộp Thư',
        loginOut: 'Đăng Xuất',
        friend: 'Mời một người bạn',
        center: {
            account: 'Tài Khoản',
            username: 'Tên đăng nhập',
            balance: 'Số dư ví',
            money: 'THB',
            name: ' Tên',
            authentication: 'Xác thực',
            phone: 'Số Điện Thoại',
            email: 'Email',
            draw: 'Nhập vào',
            wechat: '微信',
            tips: 'Lưu ý',
            congratulations: 'Chúc mừng bạn',
            success: 'Thành công',
            qqConfirm: 'QQ号认证',
            qqrule: '请输入正确的QQ号',
            qqPlace: '请输入您的QQ号',
            wechatConfirm: '微信号认证',
            wechatrule: '请输入您的微信号',
            wechatPlace: '请输入您的微信号',
            cancel: 'Hủy bỏ',
            confrim: 'Xác thực'
        },
        capital: {
            account: 'Chi Tiết Tài Khoản',
            deposit: 'Nạp Tiền',
            withdrawal: 'Rút tiền',
            bankList: 'Quản lý thẻ ngân hàng',
            withdrawalList: 'Đề xuất rút tiền',
            lockAmount: 'Chi tiết khóa',
            accountin: {
                balance: 'Tài khoản chính',
                refresh: 'Làm Mới ',
                accountBalance: 'Số dư',
                deposit: 'Nạp Tiền',
                withdrawal: 'Rút tiền',
                takeBack: 'Nhấp chuột',
                AvailBalance: 'Số dư khả dụng',
                mainBalance: 'Tài khoản chính',
                money: 'THB',
                RMB: 'RMB',
                describe: 'Chưa có dữ liệu tài khoản trò chơi ！',
                refreshSuccess: 'Số tiền trong tài khoản làm mới thành công',
                takeBacking: 'Đang truy xuất',
                takeBackError: 'Truy xuất thất bại'
            },
            depositin: {
                deposit: 'Nạp tiền',
                check: 'Vui lòng lựa chọn phương thức nạp tiền',
                amountTips: 'Số tiền nạp',
                pleaseCheck: 'Vui lòng chọn số tiền nạp',
                pleaseInput: ' Vui lòng nhập số tiền gửi',
                next: 'Kế tiếp',
                tips1: 'Lưu ý',
                tips2: ' Nếu việc nạp tiền không thành công, vui lòng thay đổi kênh thanh toán hoặc phương thức thanh toán khác.',
                tips3: ' Nếu bạn gặp bất kỳ vấn đề nào,',
                customer: 'vui lòng liên hệ chat trực tuyến .',
                CCB: '建设银行',
                ABC: '农业银行',
                ICBC: '工商银行',
                BOC: '中国银行',
                CEB: '光大银行',
                PSBC: '邮政储蓄银行',
                CITIC: '中信银行',
                BCCB: '北京银行',
                BOS: '上海银行',
                CMBC: '民生银行',
                choseTd: 'Vui lòng chọn kênh thanh toán',
                choseType: 'Vui lòng chọn phương thức thanh toán',
                choseBank: 'Vui lòng chon ngân hàng thanh toán',
                limit: ' Hạn mức tiền nạp',
                money: 'THB',
                steady: 'Ổn định',
                td: 'Kênh',
                limit2: 'Giới hạn đơn cược',
                UnionPayGateway:'thanh toán qua ví điện tử',
                BankRemittance:'Chuyển khoản ngân hàng'
            },
            withdrawalin: {
                title: ' Rút Tiền',
                amountPlace: 'Nhập số tiền rút',
                refresh: 'Làm mới số dư khả dụng',
                AvailBalance: 'Số dư khả dụng',
                money: 'THB',
                tips: '(Nếu số dư trên',
                tips3: ', bạn có thể rút tiền. Không nhập số thập phân)',
                choseBankCard: 'Vui lòng chọn tài khoản ngân hàng',
                loading: 'Tải thất bại',
                addBankCard: 'Thêm thẻ ngân hàng',
                tips2: 'Lưu ý : Để rút tiền bạn cần thiết lập mật khẩu và mã xác minh ',
                next: ' Kế tiếp',
                diatitle: 'Vui lòng nhập mật khẩu rút tiền',
                diaPlace: 'Vui lòng nhập mật khẩu rút tiền',
                confrim: 'Xác định',
                confrim1Title: ' Chưa cài đặt mật khẩu rút tiền , có cần cài đặt ?',
                confrim2Title: 'Cần xác minh số điện thoại trước khi rút tiền, có cần xác minh ?',
                confrimTips: 'Lưu ý',
                confirmText: ' Xác định',
                cancelText: 'Hủy bỏ',
                choseBank: 'Vui lòng chọn ngân hàng',
                choseAmount: 'Nếu số dư trên',
                choseAmount2: ', bạn có thể rút tiền',
                noBalance: 'Số dư không đủ',
                noPoint: 'Không nhập số thập phân',
                nopassword: 'Vui lòng nhập mật khẩu rút tiền',
                withdrawalSuccess: 'Làm lệnh rút tiền thành công, chờ xem xét',
                refreshSuccess: 'Làm mới thành công'
            },
            bankListin: {
                title1: 'Xem thẻ ngân hàng',
                title2: 'Thêm thẻ ngân hàng',
                loading: 'Tải thất bại',
                tips1: ' Lưu ý : Xóa tài khoản ngân hàng vui lòng liên hệ bộ phận chăm sóc khách hàng ',
                addBankCard: 'Thêm thẻ ngân hàng',
                bankUser: ' Tên chủ tài khoản',
                littleTips: 'Lưu ý',
                nameOnce: 'Tên chủ thẻ chỉ có thể nhập một lần, và cần phải nhập đúng tên thật. Để sửa đổi vui lòng liên hệ với bộ phận CSKH',
                namePlace: ' Vui lòng điền chính xác họ tên',
                bankNum: ' Số tài khoản ngân hàng',
                bankTips: 'Vui lòng nhập đúng thẻ ngân hàng, nếu không sẽ hiển thị sự cố',
                bankPlace: 'Vui lòng điền chính xác số tài khoản ngân hàng',
                bankName: 'Tên ngân hàng',
                bankNamePlace: 'Hãy nhập tên ngân hàng',
                subbranch: 'Tên chi nhánh ngân hàng',
                subbranchPlace: 'Tên chi nhánh ngân hàng không thể bỏ trống',
                password: 'Mật khẩu',
                passwordPlace: 'Vui lòng nhập mật khẩu rút tiền',
                add: 'Thêm',
                footer: 'Để đảm bảo sự an toàn và bảo mật, họ tên bạn nhập phải trùng khớp với tên chủ tài khoản.Cần hỗ trợ vui lòng liên hệ bộ phận chăm sóc khách hàng.',
                confirmTitle: 'Liên kết thẻ ngân hàng cần đặt mật khẩu rút tiền, Bạn có muốn đặt mật khẩu không ?',
                confirmTips: ' Lưu ý',
                confirmText: ' Xác định',
                cancelText: 'Hủy bỏ',
                cantBank: 'Không thể liên kêt thẻ ngân hàng bây giờ',
                addSuccess: 'Thêm thành công'
            },
            withdrawalListlis: {
                loading: 'Tải thất bại',
                search: 'Tìm kiếm',
                time: 'Thời gian đề xuất',
                amount: 'Số tiền đề xuất',
                status: ' Trạng thái đề xuất',
                bankName: ' Ngân hàng đề xuất',
                bankNumber: ' Tài khoản để xuất',
                remark: 'Ghi chú',
                statusAll: 'Toàn bộ',
                applying: 'Đang đề xuất',
                payment: 'Đang chuyển khoản',
                success: 'Thành công',
                reject: 'Từ chối'
            },
            lockAmountin: {
                rechargeLock: 'Khóa nạp tiền',
                allStates: 'Toàn bộ trạng thái',
                lockIn: 'Đã khóa',
                Unlocked: 'Đã mở khóa',
                Cancelled: 'Đã hủy',
                order: 'Số',
                principal: 'Nạp tiền gốc',
                lockInAmount: 'Số tiền khóa',
                targetFlow: 'Mục tiêu cần đạt (THB)',
                flowComple: 'Hoàn thành doanh thu cược ( THB)',
                lockStatus: 'Trạng thái bị khóa',
                handle: 'Hoạt động',
                deblocking: 'Mở khóa',
                discountsLock: 'Khóa ưu đãi',
                allPlatform: 'Toàn bộ nền tảng',
                mainAccount: 'Tài khoản chính',
                bonusName: 'Tên tiền thưởng',
                bonusType: 'Loại tiền thưởng',
                platform: 'Nền tảng',
                bonusLockStatus: 'Tình trạng lợi nhuận',
                deblockingSuccess: 'Đã mở khóa thành công'
            }
        },
        betlist: {
            allPlatform: 'Toàn bộ nền tảng',
            bizNo: 'Mã số cược',
            platformCode: 'Mã số',
            gameType: 'Loại trò chơi',
            betAmount: 'Số tiền cược(THB)',
            betAmount2: 'Số tiền cược:',
            betflow: 'Đặt cược hiệu quả(THB)',
            betflow2: 'Đặt cược hiệu quả:',
            resultAmount: ' Lợi nhuận người chơi(THB)',
            resultAmount2: 'Lợi nhuận người chơi:',
            betTime: ' Thời gian cược',
            createTime: 'Thời gian kết thúc',
            selectTime: 'Vui lòng chọn phạm vi thời gian',
            nobetlist: 'Không có hồ sơ cá cược! ',
            all: 'Tổng cộng:'
        },
        getBonus: {
            title: 'Trung tâm nhận thưởng',
            AccumulatedWithdrawalAmount: 'Đã tích lũy số tiền rút',
            AccumulatedBonus: 'Đã tích lũy tiền thưởng',
            canDraw: 'Có thể nhận',
            ongoing: 'Đang tiến hành',
            Finished: 'Đã hoàn thành',
            refresh: 'Click chuột làm mới',
            noData: 'Chưa có dữ liệu liên quan',
            bonusName: 'Tên ưu đãi',
            bonusMoney: 'Tiền ưu đãi',
            targetBetflow: 'Rút toàn bộ doanh thu cược',
            pendingflow: 'Sẽ hoàn thành',
            DistributionTime: 'Phân phối thời gian',
            handle: 'Hoạt động',
            draw: 'Nhận',
            total: 'Tổng{num} ghi chú',
            totalPage: ' Tổng {num} trang',
            nowPage: 'Hiện tại',
            previousPage: 'Trang trước',
            nextPage: ' Trang kế tiếp',
            success: 'Chúc mừng bạn , nhận được thành công！',
            targetFlow: ' Mục tiêu cần đạt {targetAmount}THB',
            finishedFlow: 'Đã hoàn thành doanh thu cược{validAmount} THB'
        },
        billDetail: {
            toady: 'Hôm nay',
            yesterday: 'Hôm qua',
            finalWeek: '7 ngày gần nhất',
            finalMonth: '30 ngày gần nhất',
            allType: 'Toàn bộ',
            SystemTransfer: 'Hệ thống chuyển',
            RepaidDeposit: 'Nạp tiền',
            withdrawals: 'Tốc độ rút tiền',
            SwitchToGame: 'Chuyển vào trò chơi',
            GameOut: 'Chuyển từ trò chơi',
            discounts: 'Ưu đãi',
            ManualDeposit: 'Nạp thủ công',
            ManualRemoval: 'Gỡ thủ công',
            transNo: 'Mã đơn',
            orderName: 'Tên đơn',
            orderTime: 'Thời gian',
            payType: 'Loại giao dịch',
            amount: 'Số tiền',
            status: 'Trạng thái'
        },
        myDiscountin: {
            title: 'Ưu đãi cũa tôi',
            allType: 'Tất cả các loại',
            applying: 'Đang đề xuất',
            successfulCollection: 'Nhận thành công',
            finishFlow: 'Doanh thu hoàn thành',
            cancel: 'Từ chối',
            Clearance: 'Xóa kiểm toán',
            Unclaimed: 'Chưa nhận',
            noPrize: 'Chưa rút ra',
            noOffer: 'Chưa có đề nghị nào',
            clickApply: 'Nhấn vào đây để áp dụng',
            discountItem: {
                needLaveBetflow: 'Cần đạt thêm 0 THB doanh thu có thể nhận tiền{laveBetflow}',
                needLaveBetflow2: ' Cần đạt thêm 0 THB doanh thu có thể rút tiền{laveBetflow}',
                flowDone: 'Đã đủ doanh thu cược',
                loseEfficacy: 'Không hợp lệ'
            }
        },
        safein: {
            emailTitle: 'Xác thực email',
            emailSubTitle: 'Được sử dụng lại để đặt lại mật khẩu hoặc xác thực',
            nameTitle: 'Xác thực tên',
            nameSubTitle: 'Xác thực thông tin danh tính',
            phoneTitle: 'Thêm số điện thoại',
            phoneSubTitle: 'Lấy tiền của bạn',
            vipTitle: 'Đăng nhập mật khẩu',
            vipSubTitle: 'Trang web , APP được sử dụng trước khi đăng nhập',
            codeTitle: 'Đặt mật khẩu rút tiền',
            codeSubTitle: 'Bảo mật tài khoản của bạn ',
            bankTitle: ' Đã ràng buộc tài khoản ngân hàng{length}',
            revise: 'Thay đổi',
            authen: 'Xác thực',
            receive: 'Nhận ưu đãi',
            start: 'Kích hoạt',
            customer: ' Vui lòng liên hệ với dịch vụ khách hàng để sửa đổi',
        },
        verifyEmail:{
            title:'Liên kết email',
            subTitle1:'Vui lòng nhập địa chỉ email',
            subTitle2:'Vui lòng nhập mã xác minh',
            sendcode:'Gửi mã xác minh',
            suffix: 'Gửi lại sau vài giây',
            cancel:'Hủy bỏ',
            confrim: 'Xác nhận',
            tips:'Nếu bạn quên thông tin đăng nhập,thông tin này được dùng để khôi phục tài khoản của bạn！',
            emailHadSend:'Email đã được gửi đi, vui lòng kiểm tr',
            emailConfrim:'Xác thực email',
        },
        verifyName:{
            title:'Xác thực tên thật để xác nhân thông tin chính xác',
            subTitle1:'Vui lòng nhập họ tên thật của bạn',
            subTitle2:'Vui lòng nhập mã số chứng minh nhân dân của bạn',
            cancel:'Hủy bỏ',
            confrim: 'Xác nhận',
            tips:'Để bảo vệ an ninh tài khoản và quyền hợp pháp của bạn, vui lòng xác nhận rằng danh tính tài khoản là bạn',
            nameConfrim:'Xác thực tên thật',
        },
        verifyPhone:{
            title:'Thêm số điện thoại',
            subTitle1:'Vui lòng điền số điện thoại di động',
            subTitle2:' Vui lòng nhập mã xác minh',
            sendcode:'Gửi mã xác minh',
            suffix: 'Gửi lại sau vài giây',
            cancel:'Hủy bỏ',
            confrim: 'Xác nhận',
            tips:'Nếu bạn quên thông tin đăng nhập,thông tin này được dùng để khôi phục tài khoản của bạn！',
            mileHadSend:'Tin nhắn đã được gửi đi, vui lòng kiểm tra',
            phoneConfrim:'Xác thực phone',
        },
        loginPassword:{
            title:'Sửa đổi mật khẩu đăng nhập',
            subTitle1:'Vui lòng nhập mật khẩu',
            subTitle2:' Mật khẩu đăng nhập mới',
            subTitle3:'Xác nhận mật khẩu mới',
            cancel:'Hủy bỏ',
            confrim: 'Thay đổi',
            tips:'Lưu ý : Vui lòng bảo đảm mật khẩu an toàn, Nếu bạn quên, vui lòng sử dụng chức năng lấy lại mật khẩu hoặc liên hệ với bộ phận CSKH',
            pleaseLogin:'Vui lòng đăng nhập lại',
            oldpwdError:'Lỗi định dạng mật khẩu ban đầu',
            pwdError: 'Lỗi định dạng mật khẩu mới',
            pswIsChange:'Đăng nhập mật khẩu thay đổi'
        },
        setPassword:{
            title:'Cài đặt mật khẩu rút tiền',
            subTitle1:'Đã xác thực số điện thoại',
            phoneFirst: 'Vui lòng xác thực điện thoại trước',
            subTitle2:'Vui lòng nhập mã xác minh',
            subTitle3:'Vui lòng nhập mật mã thanh toán',
            subTitle4:'Xác nhận mật khẩu mớ',
            sendcode:'Gửi mã xác minh',
            suffix: 'Gửi lại sau vài giây',
            cancel:'Hủy bỏ',
            confrim: 'Thiết lập',
            tips:'Lưu ý : Vui lòng bảo đảm mật khẩu an toàn, Nếu bạn quên, vui lòng sử dụng chức năng lấy lại mật khẩu hoặc liên hệ với bộ phận CSKH',
            mileHadSend:'Tin nhắn đã được gửi đi, vui lòng kiểm tra',
        },
        changePassword:{
            title:'Sửa đổi mật khẩu rút tiền',
            subTitle1:'Đã xác thực số điện thoại',
            phoneFirst: 'Vui lòng nhập mật mã thanh toán',
            subTitle2:'Vui lòng điền mã xác minh',
            subTitle3:'Vui lòng nhập mật khẩu thanh toán cũ',
            subTitle4:'Vui lòng nhập mật khẩu thanh toán mới',
            subTitle5:'Xác nhận mật khẩu mới',
            sendcode:'Gửi mã xác minh',
            suffix: 'Gửi lại sau vài giây',
            cancel:'Hủy bỏ',
            confrim: 'Thay đổi',
            tips:'Lưu ý : Vui lòng bảo đảm mật khẩu an toàn, Nếu bạn quên, vui lòng sử dụng chức năng lấy lại mật khẩu hoặc liên hệ với bộ phận CSKH',
            mileHadSend:'Tin nhắn đã được gửi đi, vui lòng kiểm tra',
        },
        email:{
            title:'Hộp Thư',
            mineMsg: 'Tin nhắn',
            newMsg: 'Tin nhắn mới',
            hasRead: 'Tin nhắn đã đọc',
            noMsg: 'Chưa có tin mới' ,
            del:'Xóa bỏ',
            sendMsg:'Tạo tin nhắn mới',
            msgType:'Loại tin nhắn：',
            please:'Vui lòng chọn',
            pleaseCheck:'Vui lòng chọn một câu hỏi',
            mine:' Chủ đề:',
            minePlease: 'Vui lòng nhập chủ đề',
            content: 'Nội dung:',
            contentPlaese:'Vui lòng nhập nội dung',
            send:'Gửi',
            question1:'Vấn đề gửi và rút tiền',
            question2:'Khuyến Mãi',
            question3:'Vấn đề trò chơi',
            question4:'Các vấn đề khác',
            question5:'Gợi ý',
            question6:'Khiếu nại',
            checkInfo:'Vui lòng chọn xóa thông tin',
            delSuccess:'Xóa bỏ thành công',
            submitSuccess:'Gửi thành công',
            finishContent:'Vui lòng điền hoàn tất nội dung'
        }

    },
    game:{
        playNow:'Chơi ngay',
        comingSoon:'Hãy theo dõi',
        realMoney: 'Tiền thật',
        try: 'Chơi thử',
        noData:'Không có trò chơi liên quan'
    },
    slot:{
        gameSearch:'Tìm kiếm trò chơi',
        reset:'Xóa tất cả bộ lọc',
        mineCollect: 'Bộ sưu tập',
        gameLobby: 'Sảnh trò chơi:',
        gameTypes:'Loại trò chơi',
        hotGame:'Trò chơi phổ biến',
        newGame:'Trò chơi mới nhất',
        recommend: 'Trò chơi đề xuất',
        all:'Toàn bộ',
        PrizePoolGame:'Giải thưởng',
        classicGame:'Trò chơi cổ điển ',
        xxl:'Trò chơi điện tử',
        electricHorn: 'Bắn cá',
        line:'Line',
        pleaseEnter:'Vui lòng nhập nội dung tìm kiếm',
        add:'Thêm vào bộ sưu tập',
        addSuucess:'Thêm vào bộ sưu tập thành công',
        cancelSuccess:'Xóa bỏ ra bộ sưu tập thành công',
        hadCollect:'Được yêu thích',
        late:'Vui lòng thử lại sau',
        noLogin:'Có thể vào bộ sưu tập sau khi đăng nhập',
        hotGameRank: 'Xếp hạng trò chơi cá cược hàng đầu',
        loading: 'Đang tải tuyệt đối',
        gogame: 'Vào trò chơi',
        describe: 'Vui lòng đăng nhập để xem!',
        title1: 'Đã xem gần đây',
        title2: 'Đoán bạn thích nó',
    },
    hotRanking: {
        TOP: 'Top 5 trò chơi cá cược xếp hạng',
        time: 'Thời gian thống kê:',
        hot: 'nóng nhất',
        type: 'Máy quay số cổ điển / Jackpot',
        num: 'Kích thước mã:',
        gogema: 'Tham gia ngay',
    },
    footer:{
        link: 'Liên kết nhanh',
        link2: 'Về chúng tôi',
        desc: 'Chào mừng bạn đến với VND188, trang web cá cược giải trí trực tuyến hàng đầu châu Á, mang đến cho bạn trải nghiệm cá cược trực tuyến khác nhau, bao gồm cá cược thể thao, sòng bạc trực tuyến, trò chơi sòng bạc trực tiếp, poker trực tuyến, slot game và nhiều trò chơi cá cược đẳng cấp thế giới.',
        copyright: 'Copyright © {year} | VND188 | Copyright',
        title: 'Thông tin liên quan',
        title2: 'Mối quan hệ hợp tác',
        title3: 'Dịch vụ khách hàng',
        Aboutzaza:'Giới thiệu về zaza',
        AboutzazaContent:'Trong số nhiều trang cá cược trên thị trường, người chơi chọn zaza. Ngoài các sản phẩm đa dạng, chúng tôi còn có danh tiếng tốt trong ngành và các dịch vụ chất lượng cao. Ý định của chúng tôi có thể được nhìn thấy ở mọi nơi, không có phần mềm độc hại nào và Đạt được chứng nhận quốc tế GEOTRUST để đảm bảo tính công bằng và vô tư của trang web. Tất cả dữ liệu thành viên được mã hóa để bảo vệ quyền riêng tư của người chơi. Với tinh thần phục vụ các thành viên mà không đóng cửa, chúng tôi xử lý các vấn đề liên quan đến thanh toán của thành viên 24 giờ một ngày. Đội ngũ dịch vụ khách hàng tự hào của chúng tôi rất thân thiện và chuyên nghiệp để giải quyết các vấn đề khó hiểu của người chơi với các trang web và trò chơi, để mọi người chơi đều cảm thấy như ở nhà! Những gì bạn muốn là những gì chúng tôi đã và đang theo đuổi, và chúng tôi chắc chắn là sự lựa chọn tốt nhất của bạn.',
        commonProblem:'vấn đề thường gặp',
        commonProblemContent:'Thông qua Câu hỏi thường gặp, người chơi có thể trả lời ngay các câu hỏi về việc thiết lập tài khoản zaza, nạp tiền và rút tiền và cách chơi trò chơi cá cược.',
        contactUs:'liên hệ chúng tôi',
        contactUsContent:'Người chơi có thể liên hệ với chúng tôi thông qua dịch vụ khách hàng trực tuyến 7X24 và gửi email trong Sun City VIP Lounge. Tính bảo mật của thông tin của mỗi người chơi là quan trọng nhất đối với chúng tôi và chúng tôi hứa sẽ không tiếp tục nỗ lực tuân thủ các hệ thống bảo mật và quyền riêng tư nghiêm ngặt.',
        LiveCasino:'Sòng bạc trực tiếp',
        LiveCasinoContent:'Với công nghệ cao nhất và các đại lý trực tiếp đẹp tuyệt vời, Suncity VIP Lounge cung cấp một số trò chơi sòng bạc trực tiếp phổ biến nhất, bao gồm các trò chơi sòng bạc trực tiếp như Baccarat, Blackjack, Sic Bo, Dragon Tiger và Roulette. Thông qua video trực tiếp, người chơi có thể đặt cược vào cảnh như thể họ đang ở trong trải nghiệm thú vị.',
        Bowling:'Bowling',
        BowlingContent:'Trang in-roll trò chơi thể thao mới chọn hơn 10.000 trò chơi mỗi tháng, đây là trò chơi hay nhất trong ngành. Tất nhiên, Premier League, Serie A, La Liga, Bundesliga, Champions League và các giải đấu quốc tế khác là không thể thiếu.',
        Slot:'Máy đánh bạc và trò chơi điện tử',
        SlotContent:'Với một loạt các máy đánh bạc theo chủ đề và các trò chơi điện tử, tạo ra một điểm nóng mới thú vị và cực kỳ nổi tiếng.',
        MatchResult:'Kết quả trận đấu',
        MatchResultContent:'Người chơi có thể hiểu ngay kết quả thời gian thực và cuối cùng của tất cả các sự kiện thể thao trong Hội trường VIP của Sun City.',
        LiveCasinoRules:'Quy tắc sòng bạc trực tiếp',
        LiveCasinoRulesContent:'Tất cả cá cược sòng bạc trực tiếp được thực hiện trên zaza phải tuân thủ cá cược sòng bạc trực tiếp của chúng tôi và các quy định cũng như quy tắc của nơi cấp giấy phép.',
        PokerGameRules:'Luật chơi bài xì phé',
        PokerGameRulesContent:'Tất cả các cược trò chơi poker được thực hiện trên zaza phải tuân thủ các quy định và quy tắc của trò chơi poker và nơi cấp giấy phép.',
        BettingRecord:'Kỷ lục cá cược',
        BettingRecordContent:'Thông qua hệ thống trò chơi hoặc trung tâm người dùng do zaza cung cấp, người chơi có thể kiểm tra tất cả các hồ sơ cá cược và giao dịch mọi lúc mọi nơi.',
        ModerateGambling:'Đánh bạc vừa phải',
        ModerateGamblingContent:'Chúng tôi tích cực thúc đẩy cờ bạc có kiểm soát và từ chối mạnh mẽ những người chơi chưa đủ tuổi sử dụng phần mềm của chúng tôi để giải trí trực tuyến. Đồng thời, chúng tôi sử dụng các chuyên gia và các phương pháp hiệu quả khác nhau để ngăn chặn sự xuất hiện của vấn đề đánh bạc.',

    },
    form: {
        //
        checkMoney1: 'Vui lòng chọn số tiền',
        checkMoney2: 'Lỗi định dạng số tiề',
        checkMoney3: 'Số tiền không thể là 0',
        //
        checkWithdraw: 'Vui lòng nhập mật khẩu',
        //
        checkRealname: 'Vui lòng nhập họ tên thật',
        /**校验银行卡*/
        checkBankNumber1: 'Vui lòng điền chính xác số tài khoản ngân hàng',
        checkBankNumber2: 'Lỗi định dạng thẻ ngân hàng',
        /** 校验支行*/
        checkBranch: 'Tên chi nhánh ngân hàng không thể bỏ trống',
        /** 校验邮箱 */
        checkEmail1: 'Vui lòng nhập email',
        checkEmail2: 'Lỗi định dạng email',
        /** 校验身份证 */
        checkCard1: 'Vui lòng nhập số chứng minh nhân dân',
        checkCard2: 'Lỗi định dạng số chứng minh nhân dân',
        /**校验手机号*/
        checkPhone1: 'Vui lòng nhập số điện thoại',
        checkPhone2: 'Vui long nhập chính xác số điện thoại',
        /** 校验密码 */
        checkPassword: 'Vui lòng nhập mật khẩu',
        /** 校验确认密码 */
        checkConfirm1: ' Vui lòng nhập lại mật khẩu',
        checkConfirm2: 'Nhập mật khẩu 2 lần không giống nhau',
        /** 校验原密码确认密码 */
        checkConfirms: 'Mật khẩu mới giống với mật khẩu ban đầu',
        /**校验验证码*/
        checkVerifiCode1: 'Mã xác minh không thể để trống',
        checkVerifiCode2: 'Lỗi định dạng mã xác minh',
        /** 校验账号 */
        checkUsername1: 'Vui lòng nhập tài khoản',
        checkUsername2: 'Số tài khoản bao gồm 6-12 chữ số, bắt đầu bằng một chữ cái',
        /**验证多国数字*/
        checkPhoneNumber1: 'Vui lòng nhập chính xác số điện thoại',
        checkPhoneNumber2: 'Vui lòng nhập số điện thoại ',
        /** 校验注册密码 */ 
        checkRegisterPassword1: 'Vui lòng nhập mật khẩu',
        checkRegisterPassword2: 'Mật khẩu bao gồm 6-12 chữ số và phải chứa các chữ cái và số.',
        /** 校验真实姓名 */ 
        checkrealName1:'Tên thật không thể rỗng',
        checkrealName2:'Tên thật không thể ít hơn 2 kí tự',
        /** 校验qq */ 
        checkQQ1:'QQ không thể rỗng',
        checkQQ2:'QQ không thể ít hơn 5 hay nhiều kí tự 12',
        /** 校验微信 */ 
        checkwechat1:'Wechat Không thể rỗng',
        checkwechat2:'Wechat không thể ít hơn 5 hoặc nhiều hơn 20 characters',
        /** 校验邮箱 */ 
        checkemail1:'Hộp thư Không thể rỗng',
        checkemail2:'Hộp thư không thể là ít hơn Ngũ ký tự hoặc nhiều hơn 50 ký tự',
        checkemail3:'Hãy nhập vào định dạng thư chính xác',
        /** 校验提款密码 */ 
        checkwithdrawPassword1:'Không thể rút mật khẩu',
        checkwithdrawPassword2:'Không thể dùng mật khẩu rút lui dưới 6 hay nhiều ký tự hơn 16',

    },
    common: {
        loading: 'Tải thất bại',
        loading2: 'Cập nhật danh sách',
        search: 'Tìm kiếm',
        tips: 'Lưu ý',
        congratulations: 'Chuc mừng bạn！',
        success: 'Thành công',
        confirmButtonText: ' Xác định',
        confirmButtonText2: 'Tôi biết',
        cancelButtonText:'Hủy bỏ',
        money: 'THB',
        needLogin: 'Đăng nhập để vào trò chơi',
        tryTitle:'Không có phần thưởng cho bản chơi thử , có tiếp tục không?',
        loginOut: 'Thoát ra',
        close: 'close'
    },
    timer: {
        finalWeek: 'Tuần trước',
        finalMonth: 'Tháng trước',
        finalThreeMonth: 'Ba tháng trước'

    },
    state: {
        discountsTypes: {
            all: 'Tất cả các loại',
            rebateBonus: 'Trả lại tiền thưởng',
            depositDiscount: 'Ưu đãi tiền thưởng',
            RescueFund: 'Quỹ chiết khấu',
            UpgradeAward: 'Phần thưởng nâng cấp VIP',
            WinningAwards: 'Phần thưởng VIP',
            OtherPreferences: 'Ưu đãi khác',
            RegistrationPreferences: 'Đăng ký ưu đãi'
        },
        sports_gameTypes: {
            allGame: 'Tất cả trò chơi',
            slots: 'Trò chơi điện tử',
            live: 'Live Casino',
            sport: 'Cược thể thao',
            lottery: 'Xổ số',
            fish: 'Bắn cá',
            chess: 'Cờ vua',
            other: 'Khác'
        }
    },
    filter: {
        changeName: {
            allType: 'Tất cả các loại',
            applying: 'Đang đề xuất',
            successfulCollection: 'Nhận thành công',
            finishFlow: 'Doanh thu hoàn thành',
            cancel: 'Từ chối',
            Clearance: 'Xóa kiểm toán',
            Unclaimed: 'Không nhận được',
            noPrize: 'Chưa rút ra',
        },
        bonusTypes: {
            Predividend: 'Tiền thưởng trước',
            Postdividend: 'Tiền thưởng sau',
            Deductdividends: 'Trừ tiền thưởng'
        },
        bonusName: {
            rebateBonus: 'Trả lại tiền thưởng',
            depositDiscount: 'Ưu đãi tiền thưởng',
            Invitation: 'Lời mời',
            signin: "Đăng nhập phần thưởng",
            ContinuousDeposit: 'Ưu đãi tiền gửi liên tiếp',
            register: 'Đăng ký ưu đãi',
            RescueFund: 'Quỹ chiết khấu',
            UpgradeAward: 'Phần thưởng nâng cấp VIP',
            WinningAwards: 'Phần thưởng VIP',
            OtherPreferences: 'Ưu đãi khác',
        },
        bonusLockPlatform:{
            mineAccount: 'Tài khoản chính'
        },
        bonusLockStatus:{
            status1: 'Đang khóa',
            status2: 'Đã mở khóa',
            status4: 'Đã hủy bỏ',
        },
        depositLockStatus:{
            status1: 'Đang khóa',
            status2: 'Đã mở khóa',
            status3: 'Đang khóa'
        },
        gameName:{
            name1: 'Slot Game',
            name2: 'Live',
            name3: 'Thể thao',
            name4: 'Xổ số',
            name5: 'Bắn cá',
            name6: 'Cờ vua',
            name7: 'Sảnh 3D',
        },
        changeTitle:{
            name0:'Đang tiến hành',
            name1:'Chuyển hệ thống',
            name2:'Nạp tiền ',
            name3:'Rút tiền ',
            name4:'Chuyển quỹ vào',
            name5:'Chuyển quỹ ra ',
            name8:'Thưởng ưu đãi',
            name9:'Nạp tiền thủ công',
            name10:'Rút tiền thủ công',
        },
        withdrawalStatus: {
           withdrawalStatus0: 'Áp dụng',
            withdrawalStatus1: 'Rút tiền',
            withdrawalStatus2: 'Thành công',
            withdrawalStatus3: 'Bị từ chối',
           withdrawalStatus4: 'Rút tiền',
            withdrawalStatus5: 'Rút tiền',
        }
    },
    catchFish:{
        in:'trong',
        income: 'Thu nhập gấp đôi',
        Deepsealive: 'Biển sâu sống',
        Deepsealive2: 'Cập nhật trực tiếp',
        time: 'phút trước',
        time2: 'Chụp trung bình',
        time3: 'Một',
        fishKing: 'Vua câu cá tuần trước',
        fishKing2: 'Cập nhật mỗi thứ ba',
    },
    invitation:{
        title: 'Mời bạn bè',
        title2: 'Liên kết đề xuất PC:',
        title3: 'Bạn của tôi',
        copy: 'Sao chép liên kết',
        registereduser: 'Người dùng đã đăng ký',
        time: 'thời gian',
        InviteeStatus: 'Trạng thái người được mời',
        BonusStatus: 'Trạng thái tiền thưởng',
        Received: 'Đã nhận',
        receive: 'Nhận',
        expired: 'Đã hết hạn',
        ActivityRules: 'Quy tắc hoạt động:',
        ActivityRules2: 'Người được mời cần nhận tiền thưởng trước và tài năng được mời có thể nhận được tiền thưởng. ',
        CopySuccessful: 'Sao chép thành công',
        SuccessfullyReceived: 'Đã nhận thành công',
    },
    jackpot: {
        Listofwinners: 'Danh sách chiến thắng',
        accountNumber: 'Người dùng',
        game: 'Trò chơi',
        bonus: 'Tiền thưởng',
    },
    marquree:{
        Notice:'Thông báo',
        Close:'Đóng',
    },
    ghistory: {
		title: 'Bet Detail',
		Playerid: 'Player ID',
		gameid: 'Game ID',
		insurance: 'insurance',
		WinorLoss: 'Total win/loss',
		betTime: 'Bet time:',
		orderNo: 'Txn. ID',
		Status: 'Status',
		Provider: 'Provider',
		Event: 'Event',
		betArea: 'Bet area',
        gameName: 'Game name',
		total: "Total",
		Odds: 'Odds',
		TotalBets: 'Total Bets',
		ValidBets: 'Valid Bets',
		WinorLoss2: 'Win/Loss',
		close: 'close',
		Running: 'Running',
        Settled: 'Settled',
        Game: 'Game',
	},
    ...viLocale
}

export default vi_VN


// WEBPACK FOOTER //
// ./src/pages/build902/i18n/langs/vi_VN.js